// Testimonials.jsx
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    name: "Muhammad Ali",
    position: "Home Owner – Faisalabad",
    message: "Javed Akhter and his team transformed my house! Their painting was flawless, on-time, and professional.",
    image: "/Gallerypics/Javed.png"
  },
  {
    name: "Ayesha Khan",
    position: "Commercial Project Manager",
    message: "We hired Javed Akhter Painting for our office building. Excellent work, especially on exterior walls and detailing.",
    image: "/Gallerypics/Javed.png"
  },
  {
    name: "Imran Raza",
    position: "Factory Owner – Industrial Zone",
    message: "The team did a superb job with anti-corrosion coating in our factory. Highly recommend!",
    image: "/Gallerypics/Javed.png"
  }
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false
  };

  return (
    <div style={{ background: '#f5f8fc', padding: '60px 20px' }}>
      <h1 style={{ textAlign: 'center', color: '#008080', marginBottom: '40px' }} data-aos="fade-down">Client Testimonials</h1>
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <Slider {...settings}>
          {testimonials.map((t, i) => (
            <div key={i}>
              <div style={{
                background: '#fff',
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                textAlign: 'center',
                alignItems:"center",
              }}>
                <img src={t.image} alt={t.name} className="Testimonials-img"  />
                <p style={{ fontStyle: 'italic', color: '#333' }}>
                  "{t.message}"
                </p>
                <h4 style={{ marginTop: '15px', color: '#008080' }}>{t.name}</h4>
                <p style={{ fontSize: '14px', color: '#777' }}>{t.position}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonials;
